import { useEffect, useState } from "react";
import { apiFetch } from "@/lib/api";

export function SerieAStandings() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    apiFetch(`/serie-a/standings`, { auth: false }).then((r) => setRows(r.rows || [])).catch(() => {});
  }, []);
  if (!rows.length) return null;
  const shown = open ? rows : rows.slice(0, 5);
  return (
    <section data-testid="serie-a-standings" className="mb-6 rounded-xl border border-hair bg-surfaceSecondary p-4">
      <div className="flex items-baseline justify-between mb-2">
        <h2 className="font-serif text-lg font-semibold text-onSurface">Classifica Serie A</h2>
        <span className="text-[10px] font-mono uppercase tracking-wider text-subtle">Pt · G</span>
      </div>
      <ol className="divide-y divide-hair/60">
        {shown.map((r) => (
          <li key={r.position} data-testid={`standing-row-${r.position}`} className="flex items-center gap-3 py-1.5 text-sm text-onSurface">
            <span className={`w-5 text-right font-mono text-xs ${r.position <= 4 ? "text-brand font-semibold" : "text-subtle"}`}>{r.position}</span>
            {r.crest && <img src={r.crest} alt="" className="w-4 h-4 object-contain" loading="lazy" />}
            <span className="flex-1 truncate">{r.team}</span>
            <span className="w-8 text-right font-mono font-semibold tabular-nums">{r.points}</span>
            <span className="w-6 text-right font-mono text-xs text-subtle tabular-nums">{r.played}</span>
          </li>
        ))}
      </ol>
      <button
        type="button"
        data-testid="standings-toggle"
        onClick={() => setOpen((v) => !v)}
        className="mt-2 text-xs font-mono uppercase tracking-wider text-brand hover:underline"
      >
        {open ? "Mostra meno" : "Vedi tutta la classifica"}
      </button>
    </section>
  );
}
